import React from 'react';

interface PhoneConfirmationDialogProps {
  isOpen: boolean;
  phoneNumber: string;
  onConfirm: () => void;
  onCancel: () => void;
  onEdit: () => void;
}

export const PhoneConfirmationDialog: React.FC<PhoneConfirmationDialogProps> = ({
  isOpen,
  phoneNumber,
  onConfirm,
  onCancel,
  onEdit,
}) => {
  if (!isOpen) return null;

  // Format phone number for display (07XX XXX XXX)
  const formatPhoneNumber = (phone: string) => {
    return phone.replace(/(\d{4})(\d{3})(\d{3})/, '$1 $2 $3');
  };

  return (
    <div className="fixed inset-0 bg-black/80 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-gradient-to-b from-slate-900 via-slate-900 to-black rounded-xl shadow-2xl border border-red-500/20 p-6 max-w-sm w-full mx-auto relative">
        {/* Gradient border effect */}
        <div className="absolute inset-x-0 top-0 h-px bg-gradient-to-r from-transparent via-red-500 to-transparent" />
        <div className="absolute inset-x-0 bottom-0 h-px bg-gradient-to-r from-transparent via-red-500 to-transparent" />
        <div className="absolute inset-y-0 left-0 w-px bg-gradient-to-b from-transparent via-red-500 to-transparent" />
        <div className="absolute inset-y-0 right-0 w-px bg-gradient-to-b from-transparent via-red-500 to-transparent" />

        <div className="text-center">
          <h3 className="text-lg font-medium text-white mb-4">
            Confirmă numărul de telefon
          </h3>
          
          <p className="text-gray-300 mb-2">
            Te rugăm să verifici dacă numărul tău de telefon este corect:
          </p>
          
          <p className="text-xl font-bold text-white mb-4">
            {formatPhoneNumber(phoneNumber)}
          </p>
          
          <p className="text-sm text-gray-400 mb-6">
            Vei primi un cod SMS pe acest număr pentru verificare.
          </p>

          <div className="flex flex-col gap-3">
            <button
              onClick={onConfirm}
              className="w-full px-4 py-2 bg-red-500 text-white rounded-md hover:bg-red-600 
                transition-colors duration-200 font-medium focus:outline-none focus:ring-2 
                focus:ring-red-500 focus:ring-offset-2 focus:ring-offset-gray-900"
            >
              Confirmă numărul
            </button>
            
            <button
              onClick={onEdit}
              className="w-full px-4 py-2 border border-gray-600 text-gray-300 rounded-md 
                hover:bg-gray-800 hover:border-gray-500 hover:text-white transition-colors 
                duration-200 focus:outline-none focus:ring-2 focus:ring-gray-500 
                focus:ring-offset-2 focus:ring-offset-gray-900"
            >
              Modifică numărul
            </button>
            
            <button
              onClick={onCancel}
              className="text-sm text-gray-400 hover:text-white transition-colors duration-200"
            >
              Anulează
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
